/* Behaviour for the ported prototype sections. Vanilla JS, no dependencies.
   Mirrors the React state in MadeForYou.tsx, Faq.tsx and FavoriteProducts.tsx. */
(function () {
  'use strict';

  /* --- MadeForYou: tab switching (grasscity collection-tabs behaviour).
     Hover or focus switches the tab; a click on the active tab follows its
     link, while a click on an inactive tab (touch) just switches. --- */
  function initTabs(scope) {
    var tabs = scope.querySelectorAll('[data-gc-tab]');
    if (!tabs.length) return;

    function select(index) {
      index = String(index);
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.getAttribute('data-gc-tab') === index ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-gc-tab-pane]').forEach(function (el) {
        el.hidden = el.getAttribute('data-gc-tab-pane') !== index;
      });
      scope.querySelectorAll('[data-gc-tab-hero]').forEach(function (el) {
        var on = el.getAttribute('data-gc-tab-hero') === index;
        el.classList.toggle('is-active', on);
        if (on) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      });
    }

    tabs.forEach(function (tab) {
      var index = tab.getAttribute('data-gc-tab');
      // Touch fires emulated hover/focus before click, so remember whether the
      // tab was already active when the finger went down.
      var wasActiveOnTouch = null;

      tab.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') select(index);
      });
      tab.addEventListener('pointerdown', function (e) {
        wasActiveOnTouch = e.pointerType === 'mouse' ? null : tab.getAttribute('aria-selected') === 'true';
      });
      tab.addEventListener('focus', function () {
        if (wasActiveOnTouch === null) select(index);
      });
      tab.addEventListener('click', function (e) {
        if (wasActiveOnTouch === false) {
          e.preventDefault();
          select(index);
        }
        wasActiveOnTouch = null;
      });
    });
  }

  /* --- FAQ: accordion (one open at a time, like the prototype) --- */
  function initFaq(scope) {
    var toggles = scope.querySelectorAll('[data-gc-faq-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.parentElement.querySelector('[data-gc-faq-panel]');
        var icon = btn.querySelector('svg');
        var willOpen = panel.classList.contains('hidden');

        // close all
        toggles.forEach(function (other) {
          var p = other.parentElement.querySelector('[data-gc-faq-panel]');
          var i = other.querySelector('svg');
          if (p) p.classList.add('hidden');
          if (i) i.classList.remove('rotate-45');
          other.setAttribute('aria-expanded', 'false');
        });

        if (willOpen) {
          panel.classList.remove('hidden');
          if (icon) icon.classList.add('rotate-45');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // reflect the server-rendered open state on the icon
    toggles.forEach(function (btn) {
      if (btn.getAttribute('aria-expanded') === 'true') {
        var icon = btn.querySelector('svg');
        if (icon) icon.classList.add('rotate-45');
      }
    });
  }

  /* --- FavoriteProducts: quote carousel --- */
  function initQuotes(scope) {
    var quotes = scope.querySelectorAll('[data-gc-quote]');
    if (quotes.length < 2) return;
    var counter = scope.querySelector('[data-gc-quote-counter]');
    var prev = scope.querySelector('[data-gc-quote-prev]');
    var next = scope.querySelector('[data-gc-quote-next]');
    var index = 0;

    function show(i) {
      index = (i + quotes.length) % quotes.length;
      quotes.forEach(function (q, qi) { q.classList.toggle('hidden', qi !== index); });
      if (counter) counter.textContent = index + 1 + '/' + quotes.length;
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  /* --- BestSellers: product slider arrows (the track itself is a native
     scroll-snap row, so touch swipe needs no JS) --- */
  function initSlider(scope) {
    var track = scope.querySelector('[data-gc-slider-track]');
    var prev = scope.querySelector('[data-gc-slider-prev]');
    var next = scope.querySelector('[data-gc-slider-next]');
    if (!track || !prev || !next) return;

    function step() {
      var slide = track.firstElementChild;
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (slide.offsetWidth + gap)));
      return perView * (slide.offsetWidth + gap);
    }

    // Hide the arrows (or the whole controls row, when the section has one)
    // once everything fits. Optional progress bar fill tracks the scroll.
    var controls = scope.querySelector('[data-gc-slider-controls]') || prev.parentElement;
    var progress = scope.querySelector('[data-gc-slider-progress]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      controls.hidden = max <= 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      if (progress && track.scrollWidth > 0) {
        var visible = track.clientWidth / track.scrollWidth;
        progress.style.width = visible * 100 + '%';
        progress.style.left = (max > 0 ? track.scrollLeft / max : 0) * (1 - visible) * 100 + '%';
      }
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-gc-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-gc-slider]').forEach(initSlider);
    document.querySelectorAll('[data-gc-faq]').forEach(initFaq);
    document.querySelectorAll('[data-gc-quotes]').forEach(initQuotes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();
